import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const Header = () => {

  const dispatch = useDispatch();
  const operator = useSelector(state => state.app.operator);
  const operatorStatus = useSelector(state => state.app.operatorStatus);
  const companyStatus = useSelector(state => state.app.companyStatus);
  const title = useSelector(state => state.app.title);
  const onlineConsulatant = useSelector(state => state.app.onlineConsulatant);
  const isDivWidget = useSelector(state => state.launcher.isDivWidget);
  const sendToAIAssistant = useSelector(state => state.app.sendToAIAssistant);
  const { t, i18n } = useTranslation();
  console.log('companyStatus', companyStatus);

  const isCompanyOnlineStatus = () => {
    if (sendToAIAssistant) {
      return true;
    }

    if (companyStatus) {
      return true;
    }

    return false;
  };

  return (
    <div className="kil-chat-widget-header">
      {!isDivWidget &&
        <div className={"kil-chat-widget-header-close"}
        onClick={(e) => {
          e.preventDefault();
          dispatch({ type: 'LAUNCHER_CLICKED' })
        }}>
          <i className="fal fa-times"></i>
        </div>
      }
      {operator && operator.avatar &&
        <>
        <div className="kil-chat-widget-header-avatar">
          <img src={`${operator.avatar}`} alt="" />
        </div>
        </>
      }

      <div className={"kil-chat-widget-header-title-wrap" + (operator ? ' answered' : '')}>
        {(!operator) &&
          <div className="kil-chat-widget-header-title-start">
            {title}
            <span className={"kil-chat-widget-header-title-name-status" + (isCompanyOnlineStatus() ? ' online' : '')}></span>
          </div>
        }
        
        {operator &&
          <>
          <div className="kil-chat-widget-header-title-name">
            <div>
              {operator.name}
              <span className={"kil-chat-widget-header-title-name-status" + (isCompanyOnlineStatus() ? ' online' : '')}></span>
            </div>
            <div className="kil-chat-widget-header-title-desc">
              {onlineConsulatant}
            </div>
          </div>
          </>
        }
      </div>
    </div>
  );
}

export default Header;